import { SVGFC } from '@repo/toolkit/types'

const RelationIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5978_149028)">
        <path
          d="M15.4988 9.3535C16.7469 9.3535 17.7588 8.34166 17.7588 7.0935C17.7588 5.84533 16.7469 4.8335 15.4988 4.8335C14.2506 4.8335 13.2388 5.84533 13.2388 7.0935C13.2388 8.34166 14.2506 9.3535 15.4988 9.3535Z"
          fill={color}
        />
        <path
          d="M8.49877 14.6865C9.74693 14.6865 10.7588 13.6747 10.7588 12.4265C10.7588 11.1783 9.74693 10.1665 8.49877 10.1665C7.25061 10.1665 6.23877 11.1783 6.23877 12.4265C6.23877 13.6747 7.25061 14.6865 8.49877 14.6865Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1667 14.6665C18.1667 14.3905 18.3907 14.1665 18.6667 14.1665C18.9427 14.1665 19.1667 14.3905 19.1667 14.6665V17.3332C19.1667 18.3458 18.346 19.1665 17.3333 19.1665H14C13.724 19.1665 13.5 18.9425 13.5 18.6665C13.5 18.3905 13.724 18.1665 14 18.1665H17.3333C17.7933 18.1665 18.1667 17.7932 18.1667 17.3332V14.6665Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8335 9.3335C5.8335 9.6095 5.6095 9.8335 5.3335 9.8335C5.0575 9.8335 4.8335 9.6095 4.8335 9.3335V6.66683C4.8335 5.65416 5.65416 4.8335 6.66683 4.8335H10.6668C10.9428 4.8335 11.1668 5.0575 11.1668 5.3335C11.1668 5.6095 10.9428 5.8335 10.6668 5.8335H6.66683C6.20683 5.8335 5.8335 6.20683 5.8335 6.66683V9.3335Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6641 9.06104C18.5747 9.72904 19.1667 10.807 19.1667 12.0217C19.1667 12.541 18.8394 12.9937 18.2374 13.305C17.5727 13.649 16.5367 13.833 15.4987 13.833C14.4601 13.833 13.4241 13.649 12.7594 13.305C12.1574 12.9937 11.8301 12.541 11.8301 12.0217C11.8301 10.807 12.4221 9.72904 13.3327 9.06104C13.8687 9.65037 14.6407 10.0197 15.4987 10.0197C16.3561 10.0197 17.1287 9.65037 17.6641 9.06104Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6641 14.3945C11.5747 15.0625 12.1667 16.1405 12.1667 17.3552C12.1667 17.8745 11.8394 18.3272 11.2374 18.6385C10.5727 18.9825 9.53675 19.1665 8.49875 19.1665C7.46008 19.1665 6.42408 18.9825 5.75941 18.6385C5.15741 18.3272 4.83008 17.8745 4.83008 17.3552C4.83008 16.1405 5.42208 15.0625 6.33275 14.3945C6.86875 14.9839 7.64075 15.3532 8.49875 15.3532C9.35608 15.3532 10.1287 14.9839 10.6641 14.3945Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5978_149028">
          <rect width="16" height="16" fill={color} transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RelationIcon
